import { ProductsWithoutStockApiAdapter } from '../adapters/ProductsWithoutStockApiAdapter';
import {
  Filters,
  ProductsWithoutStockModel,
  ProductsWithoutStockSummary,
} from '../models/ProductsWithoutStock';

export interface Page {
  productsWithoutStock: ProductsWithoutStockModel[];
  summary: ProductsWithoutStockSummary;
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: ProductsWithoutStockApiAdapter) {}

  async getAllMovements(
    filters: Filters = {}
  ): Promise<ProductsWithoutStockModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedMovements(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getProductsWithoutStockPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getProductsWithoutStockPaginated(filters);
  }
}
